import React, {useMemo} from 'react';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import PointTrackRadiusMarkerSingleVoyage
    from "@containers/singleVoyage/containers/track/points/pointItem/PointTrackRadiusMarkerSingleVoyage";
import {useGetMapZoomLevelFromContext} from "@ui/leafletCustom/hooks/useGetMapZoomLevel";
import {
    useCloseStopsSingleVoyage
} from "@containers/singleVoyage/containers/closeStops/useCloseStopsSingleVoyage";

const TargetPointRadiusMarkerMutateSingleVoyage = () => {

    const zoomLevel = useGetMapZoomLevelFromContext()

    const {
        points,
        targetPointId,
    } = useRootContextMutateSingleVoyage()
    const {conflictPointIds} = useCloseStopsSingleVoyage()

    const targetPoint = useMemo(() => {
        return points?.find((point) => point?.id?.toString() === targetPointId?.toString())
    }, [targetPointId, points,])

    // A stop too close to another already has its zone drawn by CloseStopsMapSingleVoyage, and this
    // marker would sit over the overlap and swallow the hover that explains it
    if (!targetPoint || conflictPointIds.has(String(targetPoint.id))) {
        return
    }
    return (
        <PointTrackRadiusMarkerSingleVoyage
            point={targetPoint}
            zoomLevel={zoomLevel}
        />
    );
};

export default TargetPointRadiusMarkerMutateSingleVoyage;